'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reduxForm = require('redux-form');

var _components = require('../../../components');

var _OMInputField = require('./OMInputField.scss');var styles = _interopRequireWildcard(_OMInputField);
var _hidePasswordIcon = require('../../../../static/icons/hide-password-icon.svg');var _hidePasswordIcon2 = _interopRequireDefault(_hidePasswordIcon);
var _revealPasswordIcon = require('../../../../static/icons/reveal-password-icon.svg');var _revealPasswordIcon2 = _interopRequireDefault(_revealPasswordIcon);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Styles
var OMInputField = function (_Component) {_inherits(OMInputField, _Component);function OMInputField() {var _temp, _this, _ret;_classCallCheck(this, OMInputField);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      type: _this.props.type,
      isInvalid: _this.props.isInvalid,
      showMobileTooltip: false,
      showTooltip: false,
      hidePassword: false }, _this.








    componentWillReceiveProps = function (_ref) {var doValidate = _ref.doValidate,isInvalid = _ref.isInvalid,initialValue = _ref.initialValue;
      if (doValidate && doValidate !== _this.props.doValidate) {
        _this.validate(_this.inputField);
      }
      if (isInvalid !== _this.props.isInvalid) {
        _this.setState({
          isInvalid: isInvalid,
          showMobileTooltip: isInvalid });

      }
      if (initialValue && initialValue !== _this.props.initialValue && _this.props.validate && _this.inputField) {
        _this.inputField.value = initialValue;
        _this.validate(_this.inputField);
      }
    }, _this.







    validate = function (target) {
      var isValid = _this.props.validate(target.value);
      if (!isValid) {
        target.classList.add('not_valid');
      } else {
        target.classList.remove('not_valid');
      }
      _this.setState({
        isInvalid: !isValid,
        showMobileTooltip: !isValid });

    }, _this.

    handleMouseEnter = function () {var
      isInvalid = _this.state.isInvalid;

      if (isInvalid) {
        _this.setState({ showTooltip: true });
      }
    }, _this.

    handleMouseLeave = function () {
      if (_this.state.showTooltip) {
        _this.setState({ showTooltip: false });
      }
    }, _this.

    handleBlur = function (event) {
      if (_this.props.fieldIsDirty) {
        _this.props.fieldIsDirty(true);
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      if (_this.props.validate && _this.startBlurValidation(_this.props.isValidIfEmpty, event.target.value)) {
        _this.validate(event.target);
      }
      if (_this.props.isInvalid) {
        event.target.classList.add('not_valid');
        _this.setState({
          isInvalid: true,
          showMobileTooltip: true,
          showTooltip: true });

      }
    }, _this.

    startBlurValidation = function (isValidIfEmpty, value) {return isValidIfEmpty ? !!value : true;}, _this.

    handleFocus = function (event) {
      event.target.classList.remove('not_valid');
      _this.setState({
        isInvalid: false,
        showMobileTooltip: false,
        showTooltip: false });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.

    handleChange = function (evt) {return _this.props.onChange && _this.props.onChange(evt);}, _this.

    handleIconClick = function (event) {
      event.preventDefault();
      _this.setState({
        showMobileTooltip: !_this.state.showMobileTooltip });

    }, _this.

    renderTooltip = function () {var _this$props =
      _this.props,tooltipMessage = _this$props.tooltipMessage,showHoverTooltip = _this$props.showHoverTooltip,isRtl = _this$props.isRtl;
      return showHoverTooltip && _this.state.isInvalid &&
      _react2.default.createElement(_components.OMPopover, { tooltipFor: _this.inputField, isRtl: isRtl },
        tooltipMessage);


    }, _this.

    renderInput = function (data) {var
      input = data.input,placeholder = data.placeholder,type = data.type,_data$meta = data.meta,touched = _data$meta.touched,error = _data$meta.error,active = _data$meta.active;
      var InputTag = _this.props.type === 'textarea' ? 'textarea' : 'input';

      return (
        _react2.default.createElement('span', null,
          _react2.default.createElement(InputTag, _extends({},
          data,
          input, {
            className: (0, _classnames2.default)({ 'has-error': error && !active && touched, touched: touched }, 'form-control'),
            placeholder: placeholder,
            type: type })),

          touched &&
          error && _react2.default.createElement('span', { className: styles.required }, _this.props.translate('errorFieldMessages', error))));


    }, _temp), _possibleConstructorReturn(_this, _ret);}OMInputField.prototype.componentDidMount = function componentDidMount() {if (this.props.initialValue && this.inputField) {this.inputField.value = this.props.initialValue;}};OMInputField.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {if (this.props.isInvalid !== nextState.isInvalid && this.props.isMobileTemporary) {this.props.validationMark(nextState.isInvalid);}};OMInputField.prototype.

  render = function render() {var _this2 = this,_cx,_cx2,_cx3;
    var InputTag = this.props.type === 'textarea' ? 'textarea' : 'input';var _props =






    this.props,tooltipMessage = _props.tooltipMessage,showHoverTooltip = _props.showHoverTooltip,isInvalid = _props.isInvalid,isMobile = _props.isMobile,isRtl = _props.isRtl,hidePasswordTitle = _props.hidePasswordTitle,revealPasswordTitle = _props.revealPasswordTitle,validate = _props.validate,fieldIsDirty = _props.fieldIsDirty,doValidate = _props.doValidate,isValidIfEmpty = _props.isValidIfEmpty,showErrorMessageDesktop = _props.showErrorMessageDesktop,isForm = _props.isForm,inputProps = _objectWithoutProperties(_props, ['tooltipMessage', 'showHoverTooltip', 'isInvalid', 'isMobile', 'isRtl', 'hidePasswordTitle', 'revealPasswordTitle', 'validate', 'fieldIsDirty', 'doValidate', 'isValidIfEmpty', 'showErrorMessageDesktop', 'isForm']);var _props2 =
    this.props,name = _props2.name,type = _props2.type,placeholder = _props2.placeholder,title = _props2.title,className = _props2.className;
    var inputType = this.state.hidePassword ? 'text' : 'password';
    var isPassword = type === 'password';

    var passwordIcon = isPassword &&
    _react2.default.createElement('div', { className: styles.iconWrapper },
      _react2.default.createElement('img', {
        className: styles.hidePassword,
        src: this.state.hidePassword ? _hidePasswordIcon2.default : _revealPasswordIcon2.default,
        onClick: function onClick() {return _this2.setState({ hidePassword: !_this2.state.hidePassword });},
        alt: this.state.hidePassword ? hidePasswordTitle : revealPasswordTitle,
        title: this.state.hidePassword ? hidePasswordTitle : revealPasswordTitle }));




    return isMobile ?
    _react2.default.createElement('div', { className: styles.mobileInput },
      isForm ?
      _react2.default.createElement(_reduxForm.Field, _extends({
        name: name,
        component: this.renderInput,
        isRtl: isRtl },
      (0, _omit2.default)(inputProps, 'initialValue'), {
        ref: function ref(inputField) {_this2.inputField = inputField;},
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        type: this.state.type === 'password' ? inputType : type,
        placeholder: placeholder,
        title: title,
        className: (0, _classnames2.default)('form-control', styles.inputField, className, { not_valid: isInvalid }),
        disabled: this.props.disabled })) :


      _react2.default.createElement(InputTag, _extends({
        ref: function ref(inputField) {_this2.inputField = inputField;} },
      (0, _omit2.default)(inputProps, 'initialValue'), {
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        name: name,
        type: this.state.type === 'password' ? inputType : type,
        placeholder: placeholder,
        title: title,
        className: (0, _classnames2.default)('form-control', styles.inputField, className, { not_valid: isInvalid }),
        disabled: this.props.disabled })),


      passwordIcon,

      this.state.showMobileTooltip && this.state.isInvalid &&
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.errorMessage, (_cx = {}, _cx[styles.passwordInput] = isPassword, _cx)) },
        tooltipMessage)) :




    _react2.default.createElement('div', {
        className: (0, _classnames2.default)(styles.wrapper, (_cx2 = {}, _cx2[styles.contactUsInput] = this.props.className === 'contactUsForm', _cx2)),
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave },

      isForm ?
      _react2.default.createElement(_reduxForm.Field, _extends({
        name: name,
        component: this.renderInput,
        isRtl: isRtl },
      (0, _omit2.default)(inputProps, 'initialValue'), {
        ref: function ref(inputField) {_this2.inputField = inputField;},
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        type: this.state.type === 'password' ? inputType : type,
        placeholder: placeholder,
        title: title,
        className: (0, _classnames2.default)('form-control', styles.inputField, className, { not_valid: isInvalid }) })) :


      _react2.default.createElement(InputTag, _extends({},
      (0, _omit2.default)(inputProps, 'initialValue'), {
        ref: function ref(inputField) {_this2.inputField = inputField;},
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        name: name,
        type: this.state.type === 'password' ? inputType : type,
        placeholder: placeholder,
        title: title,
        className: (0, _classnames2.default)('form-control', styles.inputField, className, { not_valid: isInvalid }) })),


      this.state.showTooltip && this.renderTooltip(),
      showErrorMessageDesktop && this.state.isInvalid &&
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.errorMessage, (_cx3 = {}, _cx3[styles.passwordInput] = isPassword, _cx3)) },
        tooltipMessage),


      passwordIcon);


  };return OMInputField;}(_react.Component);


OMInputField.propTypes = {
  isMobile: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  name: _propTypes2.default.string,
  initialValue: _propTypes2.default.string,
  type: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  validate: _propTypes2.default.func,
  isInvalid: _propTypes2.default.bool,
  showHoverTooltip: _propTypes2.default.bool,
  tooltipMessage: _propTypes2.default.string,
  fieldIsDirty: _propTypes2.default.func,
  doValidate: _propTypes2.default.bool,
  isValidIfEmpty: _propTypes2.default.bool,
  hidePasswordTitle: _propTypes2.default.string,
  revealPasswordTitle: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isMobileTemporary: _propTypes2.default.bool,
  validationMark: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  showErrorMessageDesktop: _propTypes2.default.bool,
  isForm: _propTypes2.default.bool };


OMInputField.defaultProps = {
  disabled: false };exports.default =


OMInputField;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMInputField/OMInputField.js
// module id = 562
// module chunks = 0